
import React, { Component, PureComponent } from 'react';

import { Heading } from '@instructure/ui-heading'

import { styleSheet } from '@matchlighter/common_library/lib/StyleSheet';
import { Watermark } from './Watermark';
import _styleSheetSrc from './Header.module.scss';
import teaIcon from '@/assets/tea_icon.svg';
// import { ProservWatermark } from './ProservWatermark';

const styles = styleSheet(_styleSheetSrc);

export const HeaderWrapper = styles.element(['inner-header-wrapper']);
export const HeaderFlex = styles.element(['header-flex']);
export const Title = styles.element(['title'], 'h1');

export class Header extends PureComponent<{ title: string, teaLogo?: boolean, actionAlign?: string }> {

    renderTeaLogo() {
        return <img className={styles('tea-logo')} src={teaIcon} />
    }

    render() {
        const { teaLogo, actionAlign } = this.props;
        return <React.Fragment>
            <HeaderWrapper style={{ paddingLeft: teaLogo ? 20 : 0 }}>
                {/* <HeaderFlex> */}
                <div className={styles({ 'header-watermark': true, 'with-tea-logo': teaLogo})}>
                    {teaLogo && this.renderTeaLogo()}
                    <span style={{ flex: 1 }} />
                    <Watermark />
                </div>
                <div className={styles`header-main`}>
                    <Heading level="h2" color="primary">{this.props.title}</Heading>
                    <div style={{ alignSelf: actionAlign }} className={styles('header-actions')}>
                        {this.props.children}
                    </div>
                </div>
                {/* </HeaderFlex> */}
            </HeaderWrapper>
        </React.Fragment>
    }
}
